const initialState = {
    inputFullname: '',
    inputMedicalSystemNumber: '',
    inputExpertiseLevel: false,
    inputSpecializedField: '',
    inputMobile: '',
    inputSecretaryMobile: '',
    inputEmail: '',
    inputAddress: '',
    inputTelephone: '',
    
};
const eliteDoctorsMembership = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_PAGE_MEMBERSHIP_ELITE_DOCTORS':
           return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default eliteDoctorsMembership;
